const shared = {
  home: 'Home',
  language: 'Ar',
  admins: 'Admins',
  lookups: 'Lookups',
  BranchesManagement: 'Branches management',
  bookings: 'Bookings',
  Branches: 'Branches',
  serviceProviderCategories: 'Service provider categories',
  serviceProviders: 'Service providers',
  publishRequests: 'Publish requests',
  specialties: 'Specialties',
  services: 'Services',
  lookupsRequests:"Lookups Requests",
  logout: 'Logout',
  lang: 'العربية',
  back: 'Back',
  noSearch: 'Sorry, No search results found!',
  noServicesAddedyet: 'Sorry, No Services add yet!',
  noSpecialtiesOnCategoryyet: 'Sorry, Category does not contain any specialties yet!',
  noEmployeesAddedyet: 'Sorry, No Employees add yet!',
  employees: 'Employees',
  customers: 'Customers',
  noData: 'There is no data yet',
  noDataToShow: 'There is no data',
  noEmployeesAdded: 'No employees added yet',
  noReviewsAdded: 'No Reviews added yet',
  noServicesAdded: 'No services added yet',
  actions: 'Actions',
  edit: 'Edit',
  add: 'Add',
  view: 'View',
  delete: 'Delete',
  save: 'Save',
  saveAndProcced: 'Save & proceed',
  done: 'Done',
  cancel: 'Cancel',
  submit: 'Submit',
  previous: 'Previous',
  filter: 'Filter',
  confirm: 'Confirm',
  copy: 'Copy',
  copied: 'Copied',
  procced: 'Proceed',
  lists: {
    enTitle: 'Title (En)',
    arTitle: 'Title (Ar)',
    enName: 'Name (En)',
    arName: 'Name (Ar)',
    name: 'Name',
    email: 'Email',
    phone: 'Phone Number',
    image: 'Image',
    categories: 'Categories',
    status: 'Status',
    category: 'Category',
    branchName: 'Branch Name',
    location: 'Location',
    rating: 'Rating',
    providerName: 'Provider’s name',
    appointmentId: 'Appointment id',
    customerName: 'Customer name',
    date: 'Date',
    transactionType:'Transaction type',
    paidAmount:'Paid amount',
    settlementAmount:'Settlement amount',
    settlementEquation:'Settlement equation',
    mimarCommission:"Mimar's commission"

  },
  filesAccepted: 'Max size: 2MB, accepted formats: jpg, jpeg, png, and bmp',
  acceptedFormatLabel: 'Accepted format',
  noOptions: 'No options',
  generalErrMsg: 'Something went wrong!',
  days: {
    sat: 'Saturday',
    sun: 'Sunday',
    mon: 'Monday',
    tus: 'Tuesday',
    wed: 'Wednesday',
    thurs: 'Thursday',
    fri: 'Friday',
  },
  closed: 'Closed',
  polygonHint: 'To confirm your zone, click inside your polygon after finishing',
  ResetPolygon: 'Reset polygon',
  settings: 'Settings',
  notifications: 'Notifications',
  admin: 'Admin',
  superAdmin: 'Super admin',
  financial: 'Financial',
  transactions:'Payment transactions',
  settlements: "Settlements & outstanding balances",
  mimarProfit: "Mimar profit",
  noInternetConnectionMsg:"No internet connection, Try again",
  noMatchedData:"No Matched Data"
};

export default shared;
